export default __webpack_public_path__ + "static/media/no-image.c3f94521.png";